import { useState, useEffect } from 'react';
import { Button, DialogContent } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { get } from '../../../lib/api';
import { DialogActions } from '../../../components/DialogActions';
import { useContext } from './context';
import { FullScreenDialog } from '../../../components/FullScreenDialog';
import { Loading } from './Loading';
import { Form } from './Form';

export function Dialog() {
  const { setLoading, user, addFarmgateDetails } = useContext();

  useEffect(() => {
    if (!user.sub) return setLoading(false);

    get(`/farmgate/users/${user.sub}`)
      .catch(() => ({}))
      .then(addFarmgateDetails)
      .then(setLoading.bind(null, false));
  }, [addFarmgateDetails, setLoading, user.sub]);

  return (
    <FullScreenDialog>
      <DialogBody />
      <DialogFooter />
    </FullScreenDialog>
  );
}

function DialogBody() {
  const { isLoading } = useContext();

  return (
    <DialogContent sx={{ px: { sx: 3, sm: 7.5 }, py: { xs: 3, sm: 4.5 } }}>
      {isLoading ? <Loading /> : <Form />}
    </DialogContent>
  );
}

function DialogFooter() {
  const { user, handleClose, handleSave, handleError, clearError, canSave } =
    useContext();
  const [isSaving, setSaving] = useState(false);

  async function save() {
    try {
      clearError();
      setSaving(true);
      await handleSave(user);
    } catch (e) {
      setSaving(false);
      handleError(e);
    }
  }

  return (
    <DialogActions dark sx={{ py: 2, px: 3, mt: 3, gap: 2 }}>
      <Button
        disabled={isSaving}
        variant="contained"
        color="inherit"
        onClick={handleClose}
      >
        Cancel
      </Button>
      <LoadingButton
        disabled={!canSave}
        variant="contained"
        onClick={save}
        loading={isSaving}
      >
        Save
      </LoadingButton>
    </DialogActions>
  );
}
